import { LitElement, html } from 'lit';
import { createRef, ref } from 'lit/directives/ref.js';
import './product-slider-categories';
import styles from './product-slider-styles';

export class FlensProductSlider extends LitElement {
	static properties = {
		imageBole: { type: String, attribute: 'image-bole' },
		categories: { type: Array },
	};

	static styles = [styles];

	constructor() {
		super();
		this.imageBole = '';
		this.categories = [];
		this._imagesRef = createRef();
		this._descriptionsRef = createRef();
		this._categoriesRef = createRef();
	}

	/** @returns {FlensSlider} */
	get imagesSlider() {
		return this._imagesRef.value?.assignedElements()[0];
	}

	/** @returns {FlensSlider} */
	get descriptionsSlider() {
		return this._descriptionsRef.value?.assignedElements()[0];
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
		this.descriptionsSlider.addEventListener('changed', () =>
			this._onSliderChanged(),
		);
		this._categoriesRef.value?.addEventListener('change', (event) =>
			this._onCategoryChange(event.detail.categoryId),
		);
	}

	_onSliderChanged() {
		this._categoriesRef.value.currentCategory =
			this.descriptionsSlider.activeSlide.categoryId;
	}

	_onCategoryChange(categoryId) {
		const scrollToSlide = this.descriptionsSlider.slides.find(
			(slide) => slide.categoryId === categoryId,
		);
		this.descriptionsSlider.moveToSlide(scrollToSlide, true);
	}

	render() {
		return html`
      <slot name="navigation"></slot>

      <div class="images-and-bole">
        <slot ${ref(this._imagesRef)} name="image-slider"></slot>
        <img class="bole-image" src="${this.imageBole}" aria-hidden="true" />
      </div>

      <div class="categories-and-descriptions">
        <flens-product-slider-categories
          ${ref(this._categoriesRef)}
          class="categories"
          categories="${JSON.stringify(this.categories)}"
        ></flens-product-slider-categories>
        <slot ${ref(this._descriptionsRef)} name="description-slider"></slot>
      </div>
    `;
	}
}

customElements.define('flens-product-slider', FlensProductSlider);
